<template>
  <div class="p-4 flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg">

    <div class="bg-white p-8 rounded-lg shadow-lg w-full sm:w-96 dark:bg-dark-box-bg dark:border dark:border-dark-border">
      <div class="text-center mb-6">
        <h2 class="text-2xl font-semibold text-gray-700 dark:text-dark-text">Logowanie</h2>
      </div>

      <form @submit.prevent="login" class="space-y-6">
        <div class="space-y-2">
          <label for="username" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Nazwa użytkownika:</label>
          <input type="text" id="username" v-model="form.username"
                 class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                 required />
        </div>

        <div class="space-y-2">
          <label for="password" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Hasło:</label>
          <input type="password" id="password" v-model="form.password"
                 class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                 required />
        </div>

        <div class="flex justify-center">
          <button type="submit" class="w-full py-3 bg-teal-700 text-white font-semibold rounded-md shadow-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:bg-teal-600 dark:hover:bg-teal-500">
            Zaloguj się
          </button>
        </div>

        <p v-if="errorMessage" class="text-red-600 text-sm mt-4">{{ errorMessage }}</p>
      </form>

      <div v-if="sessionExpired" class="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
        <div class="modal-content bg-white dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text p-8 rounded-lg w-full sm:w-96">
          <h2 class="text-xl font-semibold text-gray-800 dark:text-dark-text">Sesja wygasła</h2>
          <p class="text-gray-600 dark:text-gray-300">
            Twoja sesja wygasła. Prosimy o ponowne zalogowanie się, aby kontynuować.
          </p>
          <button
              @click="closeModal"
              class="mt-4 px-4 py-2 bg-teal-700 text-white font-semibold rounded-md shadow-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:bg-teal-600 dark:hover:bg-teal-500"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore';
import authService from '@/services/authService';
import driversService from '@/services/driversService';

export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      errorMessage: '',
      sessionExpired: false
    };
  },
  setup() {
    const authStore = useAuthStore();
    return {authStore};
  },
  mounted() {
    // Sprawdzamy, czy w parametrach URL jest informacja o wygaśnięciu sesji
    this.authStore.clearSessionAndCookies();
    if (this.$route.query.sessionExpired) {
      this.sessionExpired = true;
    }
  },
  methods: {
    async login() {
      try {
        const response = await authService.login(this.form);
        this.authStore.login(response);
        if (this.authStore.user.role === 'ROLE_ADMIN') {
          if (this.authStore.user.hasLoggedInBefore === false) {
            this.$router.push({ path: '/admin/settings', query: { hasLoggedInBefore: false } });
          } else {
            this.$router.push('/admin/orders');
          }
        } else if (['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'].includes(this.authStore.user.role)) {
          if (this.authStore.user.hasLoggedInBefore === false) {
            this.$router.push({ path: '/dispatcher/settings', query: { hasLoggedInBefore: false } });
          } else {
            this.$router.push('/dispatcher/orders');
          }
        } else if ('ROLE_DRIVER'.includes(this.authStore.user.role)) {
          if (this.authStore.user.hasLoggedInBefore === false) {
            this.$router.push({ path: '/driver/settings', query: { hasLoggedInBefore: false } });
          } else {
            this.$router.push('/driver/dashboard');
          }
        }
        
        if(this.authStore.user.role == 'ROLE_DRIVER') {
          driversService.updateDriverStatus(this.authStore.user.uid);
        }
      } catch (error) {
        this.errorMessage = error.response?.data?.message || 'Nie udało się zalogować.';
      }
    },
    closeModal() {
      this.sessionExpired = false;  // Zamknięcie modala
    }
  }
};
</script>